const polarToCartesian = (cx, cy, r, a) => {
  const angle = ((a - 90) * Math.PI) / 180;
  return {
    x: (cx + r * Math.cos(angle)).toFixed(3),
    y: (cy + r * Math.sin(angle)).toFixed(3),
  };
};

export default polarToCartesian;
